exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag[data-v-de699640]{border-radius:.375rem;font-style:italic;max-width:150px}@media (max-width:639px){.tag[data-v-de699640]{padding:.5rem 1.25rem;font-size:.75rem}}@media (min-width:640px){.tag[data-v-de699640]{font-size:.875rem;padding:.5rem 1.25rem}}", ""]);

// exports
